// extracted by mini-css-extract-plugin
var _1 = "Accordions-moduleaccordion__vVnly";
var _2 = "Accordions-modulelongButton__PlbtW";
export { _1 as "accordion", _2 as "longButton" }
